import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, TextField, Typography } from '@mui/material';

const FarmSelector = ({ farms, selectedFarmId, handleFarmSelect, farmName, setFarmName, isEditingFarm }) => {
    return (
        <>
            <Typography variant="h6" gutterBottom>Properties</Typography>
            <FormControl fullWidth margin="normal">
                <InputLabel id="farm-select-label">Select Farm</InputLabel>
                <Select
                    labelId="farm-select-label"
                    value={farms.some(f => f.id === selectedFarmId) || selectedFarmId === 'new' ? selectedFarmId : 'new'}
                    label="Select Farm"
                    onChange={(e) => handleFarmSelect(e.target.value)}
                >
                    {farms.map((f) => (
                        <MenuItem key={f.id} value={f.id}>
                            {f.fastighetsbeteckning}
                        </MenuItem>
                    ))}
                    <MenuItem value="new">
                        <em>+ Add New Farm</em>
                    </MenuItem>
                </Select>
            </FormControl>
            
            <TextField
                fullWidth
                label="Farm Name (Fastighetsbeteckning)"
                value={farmName}
                onChange={(e) => setFarmName(e.target.value)}
                margin="normal"
                disabled={selectedFarmId !== 'new' && !isEditingFarm}
            />
        </>
    );
};

export default FarmSelector;
